// extracted by mini-css-extract-plugin
export default {"par":"Education_par__2xpc8","title":"Education_title__PRrPD","education":"Education_education__ia8AG","box":"Education_box__pVkys","shake":"Education_shake__72lVe"};